// @flow

import * as React from 'react';
import {Link} from 'docs/components';
import Box from 'sail/Box';
import {Card, CardFooter, CardHeader, CardBody} from './framework';
import type {CardBadgeDefinition} from './framework';
import './ImageCard.scss';

type ImageCardProps = {|
  badge: CardBadgeDefinition,
  href: string,
  icon?: string,
  image: string,
  product: string,
  text: string,
  title: string,
|};

export const ImageCard = ({
  badge,
  href,
  icon,
  image,
  product,
  text,
  title,
}: ImageCardProps) => (
  <Card className="ImageCard">
    <Link href={href} title={title}>
      <Box className="Card-image">
        <img alt="" src={image} />
      </Box>
      <CardHeader text={title} badge={badge} />
    </Link>
    <CardBody>{text}</CardBody>
    {product && (
      <CardFooter icon={{category: 'product', icon: product}}>
        {product}
      </CardFooter>
    )}
  </Card>
);
